import TicketPresenter from "@adapters/features/TicketPortal/Presenters/TicketsPresenter";
export default (useCases, actions) => {
    return {
        ticketData: new TicketPresenter(useCases.ticketData, actions.ticketData),
    };
};
